import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { REWARD_TYPE } from 'utils/rewards';
import PurpleW from 'resources/PurpleW.png';
import SapphireIcon from 'resources/icons-currency-sapphire-sml.png';
import UberIcon from 'resources/icon-uber.png';
import WScoreIcon from 'resources/ui-icon-wscore.png';
import {
  getAvailableInfo,
  getCategoryItemClassName,
  getQuestStockCount,
  getStockInfo,
  getValidityString,
  isPurchaseEnabled,
  isQuest,
  isQuestActive,
  isUber
} from '../WStoreUtils';
import './WStoreItemNew.css';

const READ_DESCRIPTION_TEXT_LIMIT = 150;

class WStoreItemNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOverlay: false
    };

    this.defaultImage = this.defaultImage.bind(this);
  }

  truncatedDescriptionText(description) {
    if (description.length > READ_DESCRIPTION_TEXT_LIMIT) {
      return (
        <>
          {description.substring(0, READ_DESCRIPTION_TEXT_LIMIT).trim()}
          {'...'}
        </>
      );
    } else {
      return description;
    }
  }

  getCountInfo() {
    const { item } = this.props;

    const availableInfo = getAvailableInfo(item.wstoreItemCount);
    const stockInfo = getStockInfo(item.wstoreItemCount, true);
    const inStockText = stockInfo === 'Unlimited' ? 'in Stock' : '';
    const separator = <div className="separator">|</div>;

    return (
      <div className="item-count-validity">
        {availableInfo}
        {availableInfo && stockInfo && separator}
        {stockInfo}
        {inStockText}
      </div>
    );
  }

  renderRedeemButton() {
    const { item, patronAssets, onSelect } = this.props;
    const purchaseEnabled = isPurchaseEnabled(item, patronAssets);
    const buttonClass = `redeem-button${purchaseEnabled ? '' : ' disabled'}`;

    if (isQuest(item)) {
      if (isQuestActive(item)) {
        return (
          <button
            className={buttonClass + ' disabled'}
            type="button"
            onClick={() => onSelect(item)}
            disabled={true}
          >
            In Progress
          </button>
        );
      } else if (getQuestStockCount(item) <= 0) {
        return (
          <button
            className={buttonClass + ' disabled'}
            type="button"
            onClick={() => onSelect(item)}
            disabled={true}
          >
            Out of Stock
          </button>
        );
      } else {
        return (
          <button
            className={buttonClass}
            type="button"
            onClick={() => onSelect(item)}
          >
            View Quest
          </button>
        );
      }
    }

    return (
      <button
        className={buttonClass}
        type="button"
        onClick={() => onSelect(item)}
      >
        Redeem
      </button>
    );
  }

  defaultImage(e) {
    e.target.onerror = null;
    e.target.src = PurpleW;
  }

  renderValidity(item) {
    if (item.classCode === REWARD_TYPE.PARTNERS) {
      return (
        <div className="body-validity">{'Valid: ' + item.claimEndDate}</div>
      );
    }
    if (item.classCode !== 'Quest') {
      return <div className="body-validity">{getValidityString(item)}</div>;
    }
    return null;
  }

  renderCost() {
    const { item } = this.props;

    return (
      <div className="cost-section">
        <div className="total-cost">Total Cost</div>
        {item.wscore && (
          <div className="currency-section">
            <img src={WScoreIcon} alt="WScore" />
            <div className="currency-amount">{`WScore: ${item.wscore}`}</div>
          </div>
        )}
        {item.sapphireCost && (
          <div className="currency-section">
            <img src={SapphireIcon} alt="Sapphire" />
            <div className="currency-amount">{`Sapphires: ${item.sapphireCost}`}</div>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { item, preferredLocation } = this.props;
    const bodyClass = `item-body ${getCategoryItemClassName(item.classCode)}`;
    const defaultIcon = isUber(item) ? UberIcon : PurpleW;

    return (
      <div className="wstore-item-card">
        <img
          className="item-image"
          onError={this.defaultImage}
          src={item.imageUrl || defaultIcon}
          alt={item.name}
        />
        <div className={bodyClass}>
          <div className="location">{`${preferredLocation} Wind Creek`}</div>
          <div className="item-title">{item.name}</div>
          {this.getCountInfo(item)}
          {this.renderCost()}
          <div className="item-description">
            {this.truncatedDescriptionText(item.description)}
          </div>
          {this.renderRedeemButton()}
          {this.renderValidity(item)}
        </div>
      </div>
    );
  }
}

WStoreItemNew.propTypes = {
  item: PropTypes.object,
  patronAssets: PropTypes.any,
  onSelect: PropTypes.func,
  onSelectItemWithTrade: PropTypes.func,
  exchangeRates: PropTypes.shape({
    wscorePerSapphire: PropTypes.number
  }),
  isPurchaseEnabled: PropTypes.func,
  isQuest: PropTypes.func,
  isQuestActive: PropTypes.func,
  isUber: PropTypes.func
};

export default WStoreItemNew;
